import { Col, Flex, Row, Typography } from "antd";
import CustomTag from "./Tags/CustomTag";
import { CheckCircleOutlined, CloseCircleOutlined, LeftOutlined, StopOutlined } from "@ant-design/icons";
import TagAndText from "./Tags/TagAndText";
import MoveGrainStateTable from './MoveGrainStateTable';
import CustomButton from "./CustomButton";
import { useMemo } from "react";
import DangerFlashingTag from "./Tags/DangerFlashingTag";
import OverCurrentLimitTag from "./Tags/OverCurrentLimitTag";
import RemoteStopLimitTag from "./Tags/RemoteStopLimitTag";
import React from "react";
import PremierPlusBinDTO from "src/models/PremierPlusBinDTO";
import { formatTimeSpan } from "src/utils/formatting";

const { Title } = Typography;

interface MoveGrainViewProps{
    binDto: PremierPlusBinDTO | null | undefined;
}

const MoveGrain : React.FC<MoveGrainViewProps> = ({ binDto }) => {

    const textColor = { color: '#000000' }

    const currentTargetStorageBinName = useMemo ( () => {
        return binDto?.grainMovingOperation?.targetStorageBin?.name ?? "Unknown";
    }, [binDto]);

    const remainingTime = useMemo ( () => {
        return formatTimeSpan(binDto?.grainMovingOperation?.remainingGrainMovingTimeSeconds ?? 0);
    }, [binDto]);

    const ranTime = useMemo ( () => {
        return formatTimeSpan(binDto?.grainMovingOperation?.grainMovinTimeSeconds ?? 0);
    }, [binDto]);   

    const useLsgoTrigger = useMemo ( () => {
        return binDto?.grainMovingOperation?.useLowGrainShutOff;
    }, [binDto]);

    const isLgsoTriggered = useMemo( () =>{
        return binDto?.grainMovingOperation?.isLsgoTriggered;
    }, [binDto]);   
    
    return(
        <>
            <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
                <Flex vertical justify="center" style={{ padding:'20px' }}>
                    <Row justify={'space-between'}>
                        <Col>
                            <Title level={3} style={textColor}>Move Grain</Title>
                        </Col>
                        {
                            binDto?.grainMovingOperation?.shouldMoveGrain === true && 

                            <Col style={{ display:'flex', justifyContent:'flex-end', margin: '0px', padding:'0px' }}>
                                <DangerFlashingTag/>
                            </Col>
                        }
                    </Row>
                    <Row gutter={[,16]} wrap>
                        <Col>
                            <OverCurrentLimitTag binDto={binDto}/>
                        </Col>
                        <Col>
                            <RemoteStopLimitTag binDto={binDto}/>
                        </Col>
                        <Col>
                            { 
                                useLsgoTrigger &&
                                <CustomTag label={"Low grain shut off" + (isLgsoTriggered ? " NOT" : "") + " OK"} icon={isLgsoTriggered ? <CloseCircleOutlined /> : <CheckCircleOutlined />} color={isLgsoTriggered ? 'red' : 'green'} />
                            }
                        </Col>
                    </Row>
                    <br/>
                    
                    <Row style={{ position:'relative', border: '2px solid black', padding:'10px' }}>
                        <Col span={24}>
                            {
                                binDto?.grainMovingOperation?.shouldMoveGrain == true && 
                                <>
                                    <TagAndText items={[{ label: 'Grain is currently moving to: ', tag: currentTargetStorageBinName}]} />
                                    <TagAndText 
                                        items={[{ 
                                            label: 'Shut off with Low Grain Shut Off? ', 
                                            customTag: useLsgoTrigger ? {
                                                label:'YES', 
                                                icon: <CheckCircleOutlined />,
                                                color: 'green'
                                            } 
                                                : 
                                            {
                                                label:'NO',
                                                icon: <CloseCircleOutlined />,
                                                color: 'red'
                                            }}
                                        ]
                                    }/>

                                    <TagAndText items={[{ label: 'Time to run: ', tag: remainingTime }]} />
                                    <TagAndText items={[{ label: 'Total time ran: ', tag: ranTime }]} />
                                </>
                            }
                            
                            <MoveGrainStateTable binDto={binDto} />

                            <br/>

                            <Row justify={'end'} gutter={12}>
                                {
                                    binDto?.grainMovingOperation?.shouldMoveGrain === true && 
                                    <>
                                        <Col>
                                            <CustomButton 
                                            label={'CHANGE SETTINGS'} 
                                            disabled={true}
                                            />
                                        </Col>
                                        <Col>
                                            <CustomButton 
                                            variant={'danger'} 
                                            label={'STOP ALL AUGERS'} 
                                            icon={<StopOutlined />} 
                                            disabled={true}
                                            />
                                        </Col>
                                    </>
                                }
                                {
                                    binDto?.grainMovingOperation?.shouldMoveGrain === false && 
                                    <Col>
                                        <CustomButton 
                                        label={'START MOVING GRAIN'} 
                                        disabled={true}
                                        />
                                    </Col>
                                }
                            </Row>
                        </Col>
                    </Row>

                </Flex>
                <div 
                style={{
                    display: 'flex', 
                    justifyContent: 'space-between',
                    marginTop: "auto",
                    padding: 12,
                }}> 
                    <Col span={6}>
                        <CustomButton 
                        label={'Back'} 
                        variant='primary' 
                        icon={<LeftOutlined />}
                        disabled={true}
                        />
                    </Col>
                </div>
            </div>
        </>
    )
}

export default MoveGrain;